import { Court } from "@app/core/court/domain/model/court";
import { CourtApiResponse } from "@app/core/shared/domain/api-types-filtered";

export class CourtMapper {
  static deserialize(data: CourtApiResponse): Court {
    return new Court(data.id_court, data.name_court, data.integrated, data.free_of_charge);
  }
}
